import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { AbrsystemService } from '../service/abrsystem.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AViewTextModalComponent } from '../a0106-mail/a-view-text-modal.component';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

@Component({ 
    selector: 'access-log-app',
    templateUrl: './access-log.component.html',
    styleUrls: ['access-log.component.css']
})
export class AccessLogComponent implements OnInit {
    title : string = 'アクセスログ';
    isLoaded : boolean = false;
    datalist : any = [];
    all_datalist : any = [];
    queuelist:any=[];
    ROLE: any = Role;
    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 20;   /* 最大表示件数 */
    selectid:any=0;
    mode:number;
    daysmode:number=0;/*0:今日,1:昨日,2:７日間,3:14日間,4:21日間*/
    search_account:string = '';

    constructor(
        private commonService: CommonService,
        private abrsystemservice: AbrsystemService,
        public usersService: UsersService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }
    ngOnInit(): void {
        this.mode = +this.route.snapshot.paramMap.get('mode');
        this.getList();
        this.selectid = 0;
    };
    clearData (): void{
        this.isLoaded = false;
        this.datalist = [];
        this.all_datalist = [];
        this.queuelist = [];
    }
    getList(): void {
        this.clearData();
        this.abrsystemservice.getAccessLog(this.daysmode,this.search_account)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.all_datalist = res["fuel_results"]['cotract_company_list']['cotract_company'];
                if (this.all_datalist.length > 0) {
                    this.select_contract_company(this.selectid);
                    this.page = 1;
                    this.changePage(1);
                }
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    select_contract_company(i){
        this.selectid=i;
        this.all_count = this.all_datalist[this.selectid]['history'].length;
        this.page = 1;
        this.changePage(1);
    }

    changePage(e){
        var start = (e-1)*this.display_per_page;
        this.datalist = this.all_datalist[this.selectid]['history'].slice(start, start+this.display_per_page);
    }
    reload(): void {
        this.getList();
    };
    goBack(): void {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/a0117-access-log/access-log.component.ts